import cnLightGoogle from '@/assets/icons/theme_light/cn_light_google.png'
import twLightGoogle from '@/assets/icons/theme_light/tw_light_google.png'
import thLightGoogle from '@/assets/icons/theme_light/th_light_google.png'
import koLightGoogle from '@/assets/icons/theme_light/ko_light_google.png'
import ruLightGoogle from '@/assets/icons/theme_light/ru_light_google.png'
import jpLightGoogle from '@/assets/icons/theme_light/jp_light_google.png'
import frLightGoogle from '@/assets/icons/theme_light/fr_light_google.png'
import enLightGoogle from '@/assets/icons/theme_light/en_light_google.png'
import deLightGoogle from '@/assets/icons/theme_light/de_light_google.png'
import brLightGoogle from '@/assets/icons/theme_light/br_light_google.png'
import esLightGoogle from '@/assets/icons/theme_light/es_light_google.png'
import cnDarkGoogle from '@/assets/icons/theme_dark/cn_dark_google.png'
import twDarkGoogle from '@/assets/icons/theme_dark/tw_dark_google.png'
import thDarkGoogle from '@/assets/icons/theme_dark/th_dark_google.png'
import koDarkGoogle from '@/assets/icons/theme_dark/ko_dark_google.png'
import ruDarkGoogle from '@/assets/icons/theme_dark/ru_dark_google.png'
import jaDarkGoogle from '@/assets/icons/theme_dark/jp_dark_google.png'
import frDarkGoogle from '@/assets/icons/theme_dark/fr_dark_google.png'
import enDarkGoogle from '@/assets/icons/theme_dark/en_dark_google.png'
import deDarkGoogle from '@/assets/icons/theme_dark/de_dark_google.png'
import brDarkGoogle from '@/assets/icons/theme_dark/br_dark_google.png'
import esDarkGoogle from '@/assets/icons/theme_dark/es_dark_google.png'
import cnLightSafari from '@/assets/icons/theme_light/cn_light_safari.png'
import twLightSafari from '@/assets/icons/theme_light/tw_light_safari.png'
import thLightSafari from '@/assets/icons/theme_light/th_light_safari.png'
import koLightSafari from '@/assets/icons/theme_light/ko_light_safari.png'
import ruLightSafari from '@/assets/icons/theme_light/ru_light_safari.png'
import jaLightSafari from '@/assets/icons/theme_light/jp_light_safari.png'
import frLightSafari from '@/assets/icons/theme_light/fr_light_safari.png'
import enLightSafari from '@/assets/icons/theme_light/en_light_safari.png'
import deLightSafari from '@/assets/icons/theme_light/de_light_safari.png'
import brLightSafari from '@/assets/icons/theme_light/br_light_safari.png'
import esLightSafari from '@/assets/icons/theme_light/es_light_safari.png'
import cnDarkSafari from '@/assets/icons/theme_dark/cn_dark_safari.png'
import twDarkSafari from '@/assets/icons/theme_dark/tw_dark_safari.png'
import thDarkSafari from '@/assets/icons/theme_dark/th_dark_safari.png'
import koDarkSafari from '@/assets/icons/theme_dark/ko_dark_safari.png'
import ruDarkSafari from '@/assets/icons/theme_dark/ru_dark_safari.png'
import jaDarkSafari from '@/assets/icons/theme_dark/jp_dark_safari.png'
import frDarkSafari from '@/assets/icons/theme_dark/fr_dark_safari.png'
import enDarkSafari from '@/assets/icons/theme_dark/en_dark_safari.png'
import deDarkSafari from '@/assets/icons/theme_dark/de_dark_safari.png'
import brDarkSafari from '@/assets/icons/theme_dark/br_dark_safari.png'
import esDarkSafari from '@/assets/icons/theme_dark/es_dark_safari.png'
import { DictPicDefault } from "@/@types/types";

export const dictPicDefault: DictPicDefault = {
  'light': {
    'google': {
      zh: cnLightGoogle,
      tw: twLightGoogle,
      th: thLightGoogle,
      ko: koLightGoogle,
      ru: ruLightGoogle,
      jp: jpLightGoogle,
      fr: frLightGoogle,
      en: enLightGoogle,
      de: deLightGoogle,
      br: brLightGoogle,
      es: esLightGoogle,
    },
    'safari': {
      zh: cnLightSafari,
      tw: twLightSafari,
      th: thLightSafari,
      ko: koLightSafari,
      ru: ruLightSafari,
      jp: jaLightSafari,
      fr: frLightSafari,
      en: enLightSafari,
      de: deLightSafari,
      br: brLightSafari,
      es: esLightSafari,
    }
  },
  'dark': {
    'google': {
      zh: cnDarkGoogle,
      tw: twDarkGoogle,
      th: thDarkGoogle,
      ko: koDarkGoogle,
      ru: ruDarkGoogle,
      jp: jaDarkGoogle,
      fr: frDarkGoogle,
      en: enDarkGoogle,
      de: deDarkGoogle,
      br: brDarkGoogle,
      es: esDarkGoogle,
    },
    'safari': {
      zh: cnDarkSafari,
      tw: twDarkSafari,
      th: thDarkSafari,
      ko: koDarkSafari,
      ru: ruDarkSafari,
      jp: jaDarkSafari,
      fr: frDarkSafari,
      en: enDarkSafari,
      de: deDarkSafari,
      br: brDarkSafari,
      es: esDarkSafari,
    }
  }
}

export const dictPicDnaGlobal: DictPicDefault = {
  'light': {
    'google': {
      zh: cnLightGoogle,
      tw: twLightGoogle,
      th: thLightGoogle,
      ko: koLightGoogle,
      ru: ruLightGoogle,
      jp: jpLightGoogle,
      fr: frLightGoogle,
      en: enLightGoogle,
      de: deLightGoogle,
      br: brLightGoogle,
      es: esLightGoogle
    },
    'safari': {
      zh: cnLightSafari,
      tw: twLightSafari,
      th: thLightSafari,
      ko: koLightSafari,
      ru: ruLightSafari,
      jp: jaLightSafari,
      fr: frLightSafari,
      en: enLightSafari,
      de: deLightSafari,
      br: brLightSafari,
      es: esLightSafari
    }
  },
  'dark': {
    'google': {
      zh: cnDarkGoogle,
      tw: twDarkGoogle,
      th: thDarkGoogle,
      ko: koDarkGoogle,
      ru: ruDarkGoogle,
      jp: jaDarkGoogle,
      fr: frDarkGoogle,
      en: enDarkGoogle,
      de: deDarkGoogle,
      br: brDarkGoogle,
      es: esDarkGoogle
    },
    'safari': {
      zh: cnDarkSafari,
      tw: twDarkSafari,
      th: thDarkSafari,
      ko: koDarkSafari,
      ru: ruDarkSafari,
      jp: jaDarkSafari,
      fr: frDarkSafari,
      en: enDarkSafari,
      de: deDarkSafari,
      br: brDarkSafari,
      es: esDarkSafari
    }
  }
}

